import styled from '@emotion/styled'
import Button from './Button'
import Modal from './Modal'

const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
`

const ConfirmModal = ({ onClose, onConfirm, text }) => (
  <Modal maxWidth="450px" onClose={onClose}>
    <h3 className="mb4">{text}</h3>
    <Buttons>
      <Button className="mr3" secondary onClick={() => onClose()}>
        Cancel
      </Button>
      <Button warning onClick={() => onConfirm()}>
        Yes
      </Button>
    </Buttons>
  </Modal>
)

export default ConfirmModal
